import React from 'react';

import Layout from '@components/layout';
import HeroSection from '@components/hero-section';
import AboutSection from '@components/about-section';
import VrsteTransporta from '@components/vrste-transporta';
import SiloTransport from '@components/silo-transport';

const TransportPage = () => (
  <Layout pagePath="/transport" pageTitle="Transport" pageDescription="Usluge silo transporta i transporta kiperima i sanducima na području BiH.">
    <HeroSection cn="transport">
      <h1>Transport</h1>
    </HeroSection>
    <AboutSection>
      <p>
        Godinama prikupljano iskustvo u prevozu roba i uspješno poslovanje sa
        više partnera garancija su kvaliteta naših usluga: tačnost, pouzdanost i
        ekonomske cijene. Sva vozila su licencirana, redovno se održavaju i
        prolaze kontrolne tehničke ispravnosti.
      </p>
    </AboutSection>
    <VrsteTransporta />
    <SiloTransport />
  </Layout>
);

export default TransportPage;
